import { PaymentsHistoryPage, PageContainer } from "../components";

export const PaymentsHistory = () => {
  return (
    <PageContainer title="تاریخچه پرداخت ها">
      <PaymentsHistoryPage />
    </PageContainer>
  );
};
